// src/modules/restaurant/pages/respayment/components/TotalAmountCard.tsx
import React from "react";
import GroupIcon from "@mui/icons-material/Group";
import ScheduleIcon from "@mui/icons-material/Schedule";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import { OrderList } from "src/business-types/restaurant/modules/orders/types/orderTypes";

interface Props {
  order: OrderList | null;
  guess: number;
  getBgClass: () => string;
  isCompleted: boolean;
  finalAmount: string;
}

const TotalAmountCard: React.FC<Props> = ({ 
  order, 
  guess, 
  getBgClass, 
  isCompleted, 
  finalAmount 
}) => {
  const isDelivery = order?.OrderType === "Delivery";

  return (
    <div className={`relative overflow-hidden ${getBgClass()} text-white rounded-xl p-2 mb-2 shadow-lg`}>
      <div className="absolute top-0 right-0 w-24 h-24 bg-white/10 rounded-full -translate-y-8 translate-x-8"></div>
      <div className="absolute bottom-0 left-0 w-16 h-16 bg-white/5 rounded-full -translate-x-4 translate-y-4"></div>

      <div className="relative">
        {/* TOTAL : finalAmount */}
        <div className="flex items-center justify-between mb-2">
          <span className="text-xl font-bold tracking-wide">TOTAL : {finalAmount}</span>

          {/* Conditional Badge - Guest count for Dine In, "Delivery" text for Delivery */}
          {!isDelivery ? (
            <div className="flex items-center gap-1 bg-white/20 px-2 py-0.5 rounded-xl backdrop-blur-sm border border-white/30">
              <GroupIcon className="text-white text-sm" />
              <span className="text-xs font-semibold">
                {guess} Guest{guess !== 1 ? "s" : ""}
              </span>
            </div>
          ) : (
            <div className="flex items-center gap-1 bg-white/20 px-2 py-0.5 rounded-xl backdrop-blur-sm border border-white/30">
              <LocalShippingIcon className="text-white text-sm" />
              <span className="text-xs font-semibold">
                Delivery
              </span>
            </div>
          )}
        </div>
        
        {/* Date and Time - Always show */}
        <span className="flex items-center gap-1.5 font-medium">
          <ScheduleIcon className="text-sm"/>
          {order?.Ordertime || "--"} | {order?.Orderdate || "--"}
        </span>
      </div>
    </div>
  );
};

export default TotalAmountCard;